import * as React from 'react';
import { useSelector } from 'react-redux';
import { getSelectedTeamAccountContent } from '../../selectors/uiSelector';
import AdminBudgetsContainer from './admin_budgets_container';
import MealBudgetsUnSubscribed from './MealBudgetsUnSubscribed';
import { EXPENSED_MEALS_STATUS } from '../../types/expensed_meal';
export var MealBudgetsContainer = function () {
    var _a;
    var selectedTeamAccount = useSelector(getSelectedTeamAccountContent);
    var hasExpensedMealsForSelectedAccount = ((_a = selectedTeamAccount === null || selectedTeamAccount === void 0 ? void 0 : selectedTeamAccount.expensedMeals) === null || _a === void 0 ? void 0 : _a.status) === EXPENSED_MEALS_STATUS.ACTIVE;
    return !hasExpensedMealsForSelectedAccount ? (React.createElement(MealBudgetsUnSubscribed, null)) : (React.createElement(AdminBudgetsContainer, null));
};
export default MealBudgetsContainer;
